<template>
     <div class="section-container">
                <h2 class="section-title"><strong>Section 1</strong></h2>
                <form enctype="multipart/form-data" @submit="addUpdateSection1" class="section-form">
                    <div class="form-group">
                        <label class="form-label">Title</label>
                        <input class="form-input" type="text" placeholder="Enter title" v-model="section1.title" />
                    </div>
                    <div class="form-group">
                        <label class="form-label">Description</label>
                        <vue2-tinymce-editor v-model="section1.description" placeholder="Enter description" id="description1">
                        </vue2-tinymce-editor>
                    </div>
                    <div class="form-group">
                        <label class="form-label">Image</label>
                        <input class="form-input" type="file" ref="image" @change="imageOnChange" accept="image/*" />
                    </div>
                    <div class="form-group image-preview" v-if="section1.imageShow">
                        <label class="form-label">Uploaded Image</label>
                        <div class="preview-container">
                            <img :src="section1.imageShow" class="preview-image" alt="Preview" />
                        </div>
                    </div>
                    <div class="form-group submit-container">
                        <button type="submit" class="submit-button" :disabled="section1.disabled">
                            <span v-if="section1.disabled" class="loading-spinner"></span>
                            <span v-else>Submit</span>
                        </button>
                    </div>
                </form>
            </div>

</template>
<script>
/* eslint-disable */
import AppMixin from '../../mixins/AppMixin'
import Api from '../../router/api'
import { Vue2TinymceEditor } from "vue2-tinymce-editor";

export default {
    name: 'EmployeeProfileTypeView',
    mixins: [AppMixin],
    data() {
        return {
            profileType: {},
            section1: {
                title: '',
                description: '',
                image: '',
                imageShow: '',
                disabled: false
            }
        }
    },
    components: {
        Vue2TinymceEditor
    },
    methods: {
        imageOnChange: function (e) {
            let that = this;
            that.section1.image = ''
            that.section1.image = that.$refs.image.files[0];
        },
        // imageOnChangeMultiple: function () {
        //     let that = this;
        //     console.log(that.$refs.imageMultiple.files.length)
        //     for (let i = 0; i < that.$refs.imageMultiple.files.length; i++) {
        //         that.section3.image.push(that.$refs.imageMultiple.files[i]);
        //     }
        // },
        addUpdateSection1: function (e) {
            e.preventDefault()
            let that = this;
            if (!that.section1.title || !that.section1.description || !that.section1.image) {
                this.$swal({
                    icon: "error",
                    title: "error",
                    text: "Please fill all required fields",
                    showConfirmButton: true
                })
            } else {
                that.section1.disabled = true;
                const formData = new FormData();
                formData.append('image', that.section1.image);
                formData.append('title', that.section1.title);
                formData.append('description', that.section1.description);
                formData.append('profileType', that.$route.params.id);
                formData.append('id', that.section1.id);
                Api.addUpdateSection1(formData).then(response => {
                    that.section1.disabled = false;
                    this.$swal({
                        icon: "success",
                        title: "Success",
                        text: "Updated successfully",
                        showConfirmButton: true
                    }).then(function () {
                        that.section1.disabled = false
                        that.$refs.image.value = null;
                        that.getSection1()
                    });
                }).catch((error) => {
                    this.$swal({
                        icon: "error",
                        title: "error",
                        text: error.response.data.message,
                        showConfirmButton: true
                    }).then(function () {
                        that.section1.disabled = false;
                    });
                });
            }
        },
      
    },
    mounted() {
        this.getSection1()
    }
}
</script>

<style scoped>
.section-container {
    background: #ffffff;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.section-title {
    color: #0A0446;
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #e9ecef;
}

.section-form {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.form-label {
    font-weight: 600;
    color: #495057;
    font-size: 0.875rem;
}

.form-input {
    padding: 0.75rem;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    font-size: 0.875rem;
    transition: all 0.3s ease;
}

.form-input:focus {
    outline: none;
    border-color: #0A0446;
    box-shadow: 0 0 0 2px rgba(10, 4, 70, 0.1);
}

.image-preview {
    margin-top: 1rem;
}

.preview-container {
    margin-top: 0.5rem;
    border: 1px solid #e9ecef;
    border-radius: 6px;
    padding: 0.5rem;
    display: inline-block;
}

.preview-image {
    max-width: 150px;
    height: auto;
    border-radius: 4px;
}

.submit-container {
    margin-top: 1rem;
}

.submit-button {
    background-color: #0A0446;
    color: white;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 6px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    min-width: 120px;
}

.submit-button:hover:not(:disabled) {
    background-color: #080335;
    transform: translateY(-1px);
}

.submit-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.7;
}

.loading-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    border-top-color: transparent;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* TinyMCE Editor Customization */
:deep(.tox-tinymce) {
    border-radius: 6px !important;
    border-color: #e9ecef !important;
}

:deep(.tox .tox-toolbar) {
    background-color: #f8f9fa !important;
    border-bottom: 1px solid #e9ecef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Section1.vue